var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeart2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.463 1.994c-2.682-1.645-5.023-.983-6.429.073-.576.433-.864.65-1.034.65-.17 0-.458-.217-1.034-.65C8.56 1.011 6.219.35 3.537 1.994.018 4.152-.778 11.274 7.34 17.283c1.546 1.144 2.319 1.716 3.66 1.716 1.341 0 2.114-.572 3.66-1.716 8.118-6.009 7.322-13.13 3.803-15.29zM11 7v6m-3-3h6",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
export default SvgIconHeart2;